import React from "react";
import PropTypes from "prop-types";
import style from "./CustomerTabSkeleton.module.scss";

/**
 * Shimmer placeholder shown while a customer tab's data (status header +
 * left/right ConfigForm columns) is loading. Reuses the same `.form_container`
 * / `.columns` / `.column` layout classes as the real tab content so the
 * placeholder lines up with what replaces it.
 */
const SkeletonColumn = ({ fieldCount }) => (
  <div className={style.column}>
    {Array.from({ length: fieldCount }).map((_, i) => (
      <div className={style.field_row} key={i}>
        <div className={`${style.bar} ${style.label_bar}`} />
        <div className={`${style.bar} ${style.control_bar}`} />
      </div>
    ))}
  </div>
);

export const CustomerTabSkeleton = ({ fieldCount = 3 }) => (
  <div className={style.form_container} data-testid="customer-tab-skeleton">
    <div className={style.status_header}>
      <div className={`${style.bar} ${style.status_label_bar}`} />
      <div className={`${style.bar} ${style.status_label_bar}`} />
      <div className={`${style.bar} ${style.status_icon_bar}`} />
    </div>

    <div className={style.columns}>
      <SkeletonColumn fieldCount={fieldCount} />
      <SkeletonColumn fieldCount={fieldCount} />
    </div>
  </div>
);

CustomerTabSkeleton.propTypes = {
  fieldCount: PropTypes.number,
};
